/**
 * Página de Promociones
 * Muestra ofertas y descuentos actuales
 */

import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Paper,
  Stack,
} from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

export default function PromotionsPage() {
  const promotions = [
    {
      id: 1,
      title: '2x1 en productos seleccionados',
      description: 'Aprovecha nuestras ofertas especiales en artículos de la canasta básica',
      discount: '50% OFF',
      validUntil: '31 de Diciembre, 2025',
      image: '/assets/promo-2x1.jpg',
    },
    {
      id: 2,
      title: 'Descuento en compras mayores a $50.000',
      description: 'Obtén un 10% de descuento en tu compra total',
      discount: '10% OFF',
      validUntil: '15 de Enero, 2026',
      image: '/assets/promo-discount.jpg',
    },
    {
      id: 3,
      title: 'Envío gratis en pedidos superiores a $30.000',
      description: 'Sin costo de envío en compras mayores a $30.000',
      discount: 'ENVÍO GRATIS',
      validUntil: 'Permanente',
      image: '/assets/promo-shipping.jpg',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <LocalOfferIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Promociones y Ofertas
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
          Aprovecha nuestras ofertas especiales y ahorra en tus compras
        </Typography>
      </Box>

      <Stack 
        direction="row"
        flexWrap="wrap"
        spacing={4}
        sx={{ '& > *': { flex: '1 1 300px', maxWidth: '400px' } }}
      >
        {promotions.map((promo) => (
          <Box key={promo.id}>
            <Card 
              sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                }
              }}
            >
              <Box sx={{ position: 'relative' }}>
                <CardMedia
                  component="div"
                  sx={{
                    height: 200,
                    bgcolor: 'grey.200',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <TrendingDownIcon sx={{ fontSize: 80, color: 'grey.400' }} />
                </CardMedia>
                <Chip
                  label={promo.discount}
                  color="error"
                  sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    fontWeight: 'bold',
                    fontSize: '1rem',
                  }}
                />
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h5" component="h2" gutterBottom fontWeight="bold">
                  {promo.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                  {promo.description}
                </Typography>
                <Paper sx={{ p: 1.5, bgcolor: 'grey.50', mt: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Válido hasta:
                  </Typography>
                  <Typography variant="body2" fontWeight="bold">
                    {promo.validUntil}
                  </Typography>
                </Paper>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Stack>

      <Box sx={{ mt: 8, p: 4, bgcolor: 'primary.light', borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" color="primary.contrastText">
          ¿Cómo aprovechar las promociones?
        </Typography>
        <Typography variant="body1" color="primary.contrastText" paragraph>
          • Las promociones se aplican automáticamente al agregar productos elegibles al carrito
          <br />
          • Algunos descuentos requieren un mínimo de compra
          <br />
          • No se pueden combinar múltiples promociones en un mismo pedido
          <br />
          • Consulta los términos y condiciones de cada promoción
        </Typography>
      </Box>
    </Container>
  );
}
